// import { Card, notification, Table, Tag, Typography,Row,Col,Breadcrumb } from 'antd';
// import React, { useEffect } from 'react'
// import { setPayments } from '../../slices/paymentsSlice';
// import { useGetPaymentsAdminPMutation } from '../../slices/adminApiSlice';
// import { DeleteFilled, EditOutlined, UserAddOutlined, SearchOutlined ,DashboardOutlined,MoneyCollectOutlined} from '@ant-design/icons';

// import { useDispatch, useSelector } from 'react-redux';
// const { Title, Text } = Typography;

// const AdminPaymentsScreen = () => {
//       const { darkmode } = useSelector((state) => state.darkmode);
  
//   const {Text} = Typography;
//   const [api, contextHolder] = notification.useNotification();
//   const dispatch = useDispatch();
//   const { payments } = useSelector((state) => state.payments);
//   const [getpayments, { isLoading: isLoading }] = useGetPaymentsAdminPMutation();
//   const getPayments = async () => {
//     try {
//       const res = await getpayments().unwrap();
//       console.log(res.allpayments);
//       dispatch(setPayments({ ...res }));
//     } catch (err) {
//       console.log(err);
//       api.error({
//         message: err?.data?.message || err.error || err?.data?.error || err?.data?.error
//       });
//     }
//   }
//   useEffect(()=> {
//     getPayments();
//   },[])

//   const columns = [
//     {
//       title: 'Amount',
//       dataIndex: 'amount',
//       key: 'amount',
//       onCell: () => ({
//         style: {
//           whiteSpace: 'nowrap',
//         },
//       }),
//       render: (amount, payment) => `₹ ${amount / 100}`,
//     },
//     {
//       title: 'Order ID',
//       dataIndex: 'order_id',
//       key: 'order_id',
//       onHeaderCell: () => ({
//         style: {
//           whiteSpace: 'nowrap',
//         },
//       }),
//     },
//     {
//       title: 'Status',
//       dataIndex: 'status',
//       key: 'status',
//       render: (status) => (
//         <Tag color={status === 'success' ? 'green' : 'red'}>
//           {status.charAt(0).toUpperCase() + status.slice(1)}
//         </Tag>
//       ),
//     },
//     {
//       title: 'Payment ID',
//       dataIndex: 'payment_id',
//       key: 'payment_id',
//       onHeaderCell: () => ({
//         style: {
//           whiteSpace: 'nowrap',
//         },
//       }),
//       render: (payment_id) => payment_id || "N/A",
//     },
//     {
//       title: 'Plan ID',
//       dataIndex: 'plan_id', // Assuming plan has a "name" field
//       key: 'plan_id',
//       onHeaderCell: () => ({
//         style: {
//           whiteSpace: 'nowrap',
//         },
//       }),
//       render: (plan_id) => plan_id,
//     },
//     {
//       title: 'User ID',
//       dataIndex: 'user_id', // Assuming user has an "email" field
//       key: 'user_id',
//       onHeaderCell: () => ({
//         style: {
//           whiteSpace: 'nowrap',
//         },
//       }),
//       render: (user_id) => user_id,
//     },
//   ];
//   return (
//     <div>


//       <Title
//       style={{
//         fontFamily: 'Inter, sans-serif',
//         marginBottom: '16px', // Added margin below title
//       }}
//       level={2}
//     >
//       <MoneyCollectOutlined /> &nbsp;All Payments
//     </Title>

//     <Row
//       style={{
//         padding: "20px",
//         backgroundColor: darkmode ? "#141414" : "#FFF",
//         borderRadius: "5px",
//         marginBottom: "20px", // Added spacing below breadcrumb row
//       }}
//     >
//       <Col flex="auto">
//         <Breadcrumb
//           items={[{ title: 'payment' }, { title: 'All Payments' }]}
//           style={{ marginBottom: "5px" }}
//         />
//       </Col>
//     </Row>
//     <contextHolder/>

//       <Card title="All Payments" loading={isLoading}>

//         <Table
//           columns={columns}
//           dataSource={payments ? payments : []}
//           loading={false}
//           rowKey={(payment) => payment._id}
//           pagination={{ pageSize: 10 }}
//           size='small'
//           style={{width: "100%"}}
//           scroll={{x: "scroll"}} 
//           tableProps={{ tableLayout: "fixed"}} 
//         />
//       </Card>
//     </div>
//   )
// }

// export default AdminPaymentsScreen


import { Card, notification, Table, Tag, Typography,Row,Col,Breadcrumb } from 'antd';
import React, { useEffect } from 'react'
import { setPayments } from '../../slices/paymentsSlice';
import { useGetPaymentsAdminPMutation } from '../../slices/adminApiSlice';
import { DeleteFilled, EditOutlined, UserAddOutlined, SearchOutlined ,DashboardOutlined,MoneyCollectOutlined} from '@ant-design/icons';

import { useDispatch, useSelector } from 'react-redux';
const { Title, Text } = Typography;

const AdminPaymentsScreen = () => {
      const { darkmode } = useSelector((state) => state.darkmode);
  
  const {Text} = Typography;
  const [api, contextHolder] = notification.useNotification();
  const dispatch = useDispatch();
  const { payments } = useSelector((state) => state.payments);
  const [getpayments, { isLoading: isLoading }] = useGetPaymentsAdminPMutation();
  const getPayments = async () => {
    try {
      const res = await getpayments().unwrap();
      console.log(res.allpayments);
      dispatch(setPayments({ ...res }));
    } catch (err) {
      console.log(err);
      api.error({
        message: err?.data?.message || err.error || err?.data?.error || err?.data?.error
      });
    }
  }
  useEffect(()=> {
    getPayments();
  },[])

  const columns = [
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      onCell: () => ({
        style: {
          whiteSpace: 'nowrap',
        },
      }),
      render: (amount, payment) => `₹ ${amount / 100}`,
    },
    {
      title: 'Order ID',
      dataIndex: 'order_id',
      key: 'order_id',
      onHeaderCell: () => ({
        style: {
          whiteSpace: 'nowrap',
        },
      }),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag color={status === 'success' ? 'green' : 'red'}>
          {status.charAt(0).toUpperCase() + status.slice(1)}
        </Tag>
      ),
    },
    {
      title: 'Payment ID',
      dataIndex: 'payment_id',
      key: 'payment_id',
      onHeaderCell: () => ({
        style: {
          whiteSpace: 'nowrap',
        },
      }),
      render: (payment_id) => payment_id || "N/A",
    },
    {
      title: 'Plan ID',
      dataIndex: 'plan_id', // Assuming plan has a "name" field
      key: 'plan_id',
      onHeaderCell: () => ({
        style: {
          whiteSpace: 'nowrap',
        },
      }),
      render: (plan_id) => plan_id,
    },
    {
      title: 'Billing Mode',
      dataIndex: 'autopay',
      key: 'autopay',
      onHeaderCell: () => ({
        style: {
          whiteSpace: 'nowrap',
        },
      }),
      render: (autopay) =>
        autopay ? <Tag color="green">Autopay</Tag> : <Tag color="default">One-time</Tag>,
    },
    {
      title: 'User ID',
      dataIndex: 'user_id', // Assuming user has an "email" field
      key: 'user_id',
      onHeaderCell: () => ({
        style: {
          whiteSpace: 'nowrap',
        },
      }),
      render: (user_id) => user_id,
    },
  ];
  return (
    <div>


      <Title
      style={{
        fontFamily: 'Inter, sans-serif',
        marginBottom: '16px', // Added margin below title
      }}
      level={2}
    >
      <MoneyCollectOutlined /> &nbsp;All Payments
    </Title>

    <Row
      style={{
        padding: "20px",
        backgroundColor: darkmode ? "#141414" : "#FFF",
        borderRadius: "5px",
        marginBottom: "20px", // Added spacing below breadcrumb row
      }}
    >
      <Col flex="auto">
        <Breadcrumb
          items={[{ title: 'payment' }, { title: 'All Payments' }]}
          style={{ marginBottom: "5px" }}
        />
      </Col>
    </Row>
    <contextHolder/>

      <Card title="All Payments" loading={isLoading}>

        <Table
          columns={columns}
          dataSource={payments ? payments : []}
          loading={false}
          rowKey={(payment) => payment._id}
          pagination={{ pageSize: 10 }}
          size='small'
          style={{width: "100%"}}
          scroll={{x: "scroll"}} 
          tableProps={{ tableLayout: "fixed"}} 
        />
      </Card>
    </div>
  )
}

export default AdminPaymentsScreen